"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconMoney = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M4,7 L20,7 L20,17 L4,17 L4,7 M12,9.5 C13.4727593,9.5 14.6666667,10.6192881 14.6666667,12 C14.6666667,13.3807119 13.4727593,14.5 12,14.5 C10.5272407,14.5 9.33333333,13.3807119 9.33333333,12 C9.33333333,10.6192881 10.5272407,9.5 12,9.5 M7.55555556,8.66666667 C7.55555556,9.58714125 6.75961733,10.3333333 5.77777778,10.3333333 L5.77777778,13.6666667 C6.75961733,13.6666667 7.55555556,14.4128588 7.55555556,15.3333333 L16.4444444,15.3333333 C16.4444444,14.4128588 17.2403827,13.6666667 18.2222222,13.6666667 L18.2222222,10.3333333 C17.2403827,10.3333333 16.4444444,9.58714125 16.4444444,8.66666667 L7.55555556,8.66666667 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconMoney')(IconMoney);